import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = [
    "source",
    "copiedIndicator"
  ]

  connect() {
    // Hide the copied indicator on connect
    if (this.hasCopiedIndicatorTarget) {
      this.copiedIndicatorTarget.style.display = "none";
    }
  }

  copy(event) {
    // Prevent the default action of the trigger element
    event.preventDefault();

    // Select the text in the input
    this.sourceTarget.select();
    
    // Copy the content from the sourceTarget to the clipboard
    navigator.clipboard.writeText(this.sourceTarget.value || this.sourceTarget.dataset.clipboardText)
      .then(() => {
        // Show the copied indicator
        if (this.hasCopiedIndicatorTarget) {
          this.copiedIndicatorTarget.style.display = "flex";
          
          // Hide the copied indicator after 2 seconds
          setTimeout(() => {
            this.copiedIndicatorTarget.style.display = "none";
          }, 2000);
        }
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
        // Fallback copy method for older browsers
        try {
          document.execCommand('copy');
          
          // Show the copied indicator
          if (this.hasCopiedIndicatorTarget) {
            this.copiedIndicatorTarget.style.display = "flex";
            
            // Hide the copied indicator after 2 seconds
            setTimeout(() => {
              this.copiedIndicatorTarget.style.display = "none";
            }, 2000);
          }
        } catch (err) {
          console.error('Fallback copy failed: ', err);
          alert('Please copy the link manually');
        }
      });
  }
}
